"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TicketMessage = exports.MessageTypeEnum = void 0;
const typeorm_1 = require("typeorm");
const data_ui_1 = require("../data-ui");
const ticket_1 = require("./ticket");
var MessageTypeEnum;
(function (MessageTypeEnum) {
    MessageTypeEnum["OFFLINE_LEGACY"] = "M";
    MessageTypeEnum["CHAT"] = "C";
    MessageTypeEnum["CALL"] = "P";
    MessageTypeEnum["OUTGOING_CALL"] = "V";
    MessageTypeEnum["INTERNAL_CALL"] = "1";
    MessageTypeEnum["INTERNAL"] = "I";
    MessageTypeEnum["INTERNAL_OFFLINE"] = "U";
    MessageTypeEnum["INTERNAL_COLLAPSED"] = "Z";
    MessageTypeEnum["STARTINFO"] = "S";
    MessageTypeEnum["TRANSFER"] = "T";
    MessageTypeEnum["RESOLVE"] = "R";
    MessageTypeEnum["POSTPONE"] = "J";
    MessageTypeEnum["DELETE"] = "X";
    MessageTypeEnum["SPAM"] = "B";
    MessageTypeEnum["TAG"] = "G";
    MessageTypeEnum["FACEBOOK"] = "F";
    MessageTypeEnum["TWITTER"] = "W";
    MessageTypeEnum["RETWEET"] = "Y";
    MessageTypeEnum["KNOWLEDGEBASE_START"] = "A";
    MessageTypeEnum["KNOWLEDGEBASE"] = "K";
    MessageTypeEnum["FORWARD"] = "O";
    MessageTypeEnum["FORWARD_REPLY"] = "Q";
    MessageTypeEnum["SPLITTED"] = "L";
    MessageTypeEnum["MERGED"] = "2";
    MessageTypeEnum["INCOMING_EMAIL"] = "3";
    MessageTypeEnum["OUTGOING_EMAIL"] = "4";
    MessageTypeEnum["OFFLINE"] = "5";
    MessageTypeEnum["TYPE_WHATSAPP"] = "6";
    MessageTypeEnum["TYPE_RECEIVED_ANSWER"] = "7";
})(MessageTypeEnum = exports.MessageTypeEnum || (exports.MessageTypeEnum = {}));
let TicketMessage = class TicketMessage {
};
__decorate([
    (0, typeorm_1.PrimaryGeneratedColumn)(),
    __metadata("design:type", Number)
], TicketMessage.prototype, "id", void 0);
__decorate([
    (0, typeorm_1.Column)({ name: 'message_id', unique: true }),
    __metadata("design:type", String)
], TicketMessage.prototype, "messageId", void 0);
__decorate([
    (0, typeorm_1.Column)({ type: 'enum', enum: MessageTypeEnum }),
    __metadata("design:type", String)
], TicketMessage.prototype, "type", void 0);
__decorate([
    (0, typeorm_1.Column)({ nullable: true }),
    __metadata("design:type", String)
], TicketMessage.prototype, "from", void 0);
__decorate([
    (0, typeorm_1.Column)({ nullable: true }),
    __metadata("design:type", String)
], TicketMessage.prototype, "to", void 0);
__decorate([
    (0, typeorm_1.Column)({ nullable: true }),
    __metadata("design:type", String)
], TicketMessage.prototype, "subject", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    __metadata("design:type", String)
], TicketMessage.prototype, "content", void 0);
__decorate([
    (0, typeorm_1.Column)({ type: 'jsonb', nullable: true }),
    __metadata("design:type", Array)
], TicketMessage.prototype, "attachments", void 0);
__decorate([
    (0, typeorm_1.Column)({ name: 'created_at' }),
    __metadata("design:type", String)
], TicketMessage.prototype, "createdAt", void 0);
__decorate([
    (0, typeorm_1.Index)(),
    (0, typeorm_1.ManyToOne)(() => ticket_1.Ticket, (ticket) => ticket.messages),
    (0, typeorm_1.JoinColumn)({ name: 'ticket_id' }),
    __metadata("design:type", ticket_1.Ticket)
], TicketMessage.prototype, "ticket", void 0);
TicketMessage = __decorate([
    data_ui_1.DataUi.Name({
        name: 'Ticket Messages',
    }),
    (0, typeorm_1.Entity)('ticket_messages', { schema: 'public' })
], TicketMessage);
exports.TicketMessage = TicketMessage;
//# sourceMappingURL=ticket-messages.js.map